import { render } from "./maternity_bed_assignment.vue?vue&type=template&id=19225e18&scoped=true"
import script from "./maternity_bed_assignment.vue?vue&type=script&lang=js"
export * from "./maternity_bed_assignment.vue?vue&type=script&lang=js"

import "./maternity_bed_assignment.vue?vue&type=style&index=0&id=19225e18&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19225e18"]])

export default __exports__